import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ['container']

  toggle() {
    this.containerTarget.classList.toggle('d-none')
  }
}
